import React from "react";
import { Grid } from "@mui/material";
import { FaCircleCheck } from "react-icons/fa6";
import "./WhoWeAre.css";

const WhoWeAre = ({ whoWeAreData, whoWeAreLoading }) => {
  return (
    <section className="who-we-are-section">
      <div className="common-sec">
        <Grid
          container
          rowSpacing={2}
          columnSpacing={{ xs: 2, sm: 3, md: 4, lg: 5 }}
          alignItems="center"
        >
          <Grid item xs={12} lg={6}>
          <div className="who-we-are-image-wrap">
              {!whoWeAreLoading && whoWeAreData?.home_image ? (
                <img
                  src={whoWeAreData.home_image}
                  alt="Anax Lifescience"
                  className="who-we-are-img"
                />
              ) : (
                <div className="shimmer-image" />
              )}
            </div>
           
          </Grid>
          <Grid item xs={12} lg={6}>
          <header className="who-we-are-header">
              <span className="who-we-are-badge">Who We Are</span>
              {!whoWeAreLoading && whoWeAreData?.title ? (
                <h2 className="who-we-are-title">{whoWeAreData.title}</h2>
              ) : (
                <div className="who-we-are-title-shimmer" />
              )}
            </header>
            <div className="who-we-are-content">
              {!whoWeAreLoading && whoWeAreData?.points?.length ? (
                <ul className="who-we-are-list">
                  {whoWeAreData.points.map((point, index) => (
                    <li key={index}>
                      <FaCircleCheck className="who-we-are-icon" aria-hidden />
                      <span>{point}</span>
                    </li>
                  ))}
                </ul>
              ) : (
                <div className="shimmer-list-items">
                  {[1, 2, 3, 4].map((i) => (
                    <div key={i} className="shimmer-list-item" />
                  ))}
                </div>
              )}
            </div> 
          </Grid>
        </Grid>
      </div>
    </section>
  );
};

export default WhoWeAre;
